export const COMPANY_SETTINGS = {
  LIBRARY_SETTINGS: "librarySettings",
  LIBRARY_WT: "libraryWorkTypes",
  TRIAL_ALERT: "trialAlert",
  HOME_COLUMNS: "columns",
  RATES: "rates",
  PRESET: "defaultPresetId",
  TEMPLATE: "defaultTemplateId",
  ESTIMATION_UNIT: "defaultEstimationUnit",
  TIME_EQUIV: "timeEquiv",
  CURRENCY_DEF: "defaultCurrency",
  PRICE_FORMAT_DEF: "defaultPriceFormat",
  COMPANY_CURRENCY: "companyCurrency",
  HIDDEN_WT: "hiddenWorkTypes",

  DOMAIN: "domain",
  DOMAIN_USE: "useDomain",
  DOMAIN_CNAME: "cnameName",
  DOMAIN_VALUE: "cnameValue",
  
  INVOICE_EMAIL: "invoiceEmail",
  INVOICE_SEND: "sendInvoiceEmail",
  
  XLS_CONFIG: "defaultXlsConfig",
};

export const USER_COMPANY_SETTINGS = {
  AVERAGE_ALERT: (userUuid) => `projectAverageAlert${userUuid}`,
  RISK_ALERT: (userUuid) => `projectRiskBufferAlert${userUuid}`,
  RESIZE_ALERT: (userUuid) => `projectResizeAlert${userUuid}`,
  HIDE_TIMELINE_SECTION_ALERT: (userUuid) => `hideTimelineSectionAlert${userUuid}`,
  // LATEST_UPDATES_SEEN: (userUuid) => `seenLatestUpdates${userUuid}`,
};

export const PROJECT_COMPANY_SETTINGS = {
  VALUE_ALERT: (estimateUuid) => `projectValueAlert${estimateUuid}`,
  VALUE_PROJECT: (estimateUuid) => `projectDifferentValue-${estimateUuid}`,
}
